<template>
  <div class="phone-confirm mb-3">

    <div v-if="confirmed" class="alert alert-success mt-2">
      <div class="fw-bold"><span class="me-1">&#10003;</span>{{ trans('phone_confirmed') }}</div>
      <div>{{ trans('after_payment_tickets_will_be_sent_to_number') }}</div>
    </div>

    <div v-else-if="checkouttime > 0">
      <button v-if="!codeSent"
              type="button"
              class="btn btn-themed btn-outline-secondary btn-get-code mt-2"
              :disabled="!phoneIsFilled || sending"
              @click="sendCode">
        {{ trans('get_confirmation_code') }}
      </button>

      <div v-else>
        <div class="text-success mt-3"><span class="me-1">&#10003;</span>{{ trans('code_is_sent') }}</div>
        <div class="note-ch mb-3 mt-2">{{ trans('enter_code_sent_to') }} {{ phone }}</div>
        <v-otp-input
            ref="otpInput"
            input-classes="otp-input otp-input-sm"
            separator=""
            :num-inputs="length"
            :should-auto-focus="true"
            :is-input-num="true"
            v-model="otp"
            @on-change="handleOnChange"
            @on-complete="handleOnComplete"
        />
        <div v-if="wrongOtp" class="small text-danger mt-2">
          {{ trans('wrong_otp_check_and_try_again') }}
        </div>
        <div class="mt-3">
          <div v-if="codeResent" class="text-success">
            <span class="me-1">&#10003;</span>{{ trans('code_sent_again') }}
          </div>
          <div v-else-if="secondsLeft > 0">
            <span class="note-ch">{{ trans('send_again_after') }}:</span>
            <span class="ms-1 fw-bold">{{ formattedSecondsLeft }}</span>
          </div>
          <div v-else>
          <a class="text-dark-blue pointer fw-bold"
             :class="{ inactive: sending }"
             @click="sendCode">
            {{ trans('send_code_again') }}
          </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "PhoneConfirm",
  props: {
    phone: {
      type: String,
      default: ''
    },
    confirmed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState([
      'order',
      'checkouttime',
    ]),
    phoneIsFilled() {
      return String(this.phone || '').replace(/[^0-9]/g, '').length >= 11
    },
    formattedSecondsLeft() {
      const minutes = Math.floor(this.secondsLeft / 60)
      const seconds = this.secondsLeft % 60
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    }
  },
  data() {
    return {
      length: 4,
      otp: '',
      timer: null,
      secondsLeft: 0,
      wrongOtp: false,
      codeSent: false,
      codeResent: false,
      sending: false
    }
  },
  methods: {
    async sendCode() {
      if(this.secondsLeft > 0 || this.sending || !this.phoneIsFilled) return
      const wasAlreadySent = this.codeSent
      this.sending = true
      try {
        const res = await axios.post(`/api/order/${this.order.id}/${this.order.hash}/phone/confirm/generate`, { phone: this.phone })
        const d = res.data
        if(d && d.success) {
          this.codeSent = true
          if(wasAlreadySent) this.codeResent = true
          this.otp = ''
          this.wrongOtp = false
          this.launchTimer(d.seconds_left || 60)
        } else {
          if(d && d.seconds_left) {
            this.codeSent = true
            this.launchTimer(d.seconds_left)
          }
          if(d && d.error) window.noty(d.error, 'error')
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.sending = false
      }
    },
    async checkOTP() {
      if(this.otp.length !== this.length) return
      try {
        const res = await axios.post(`/api/order/${this.order.id}/${this.order.hash}/phone/confirm/check`, {
          phone: this.phone,
          code: this.otp
        })
        if(res.data && res.data.success) {
          this.reset()
          this.$emit('confirmed', res.data.phone_confirmed || this.phone)
        } else {
          this.wrongOtp = true
        }
      } catch (e) {
        console.log(e)
      }
    },
    launchTimer(seconds) {
      this.secondsLeft = seconds
      if(this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.secondsLeft--
        if(this.secondsLeft <= 0) clearInterval(this.timer)
      }, 1000)
    },
    reset() {
      if(this.timer) clearInterval(this.timer)
      this.timer = null
      this.secondsLeft = 0
      this.codeSent = false
      this.codeResent = false
      this.wrongOtp = false
      this.otp = ''
    },
    handleOnChange(val) {
      this.otp = val
    },
    handleOnComplete(val) {
      this.otp = val
    }
  },
  beforeDestroy() {
    if(this.timer) clearInterval(this.timer)
  },
  watch: {
    otp(val) {
      this.wrongOtp = false
      if(val.length === this.length) this.checkOTP()
    },
    phone() {
      this.reset()
    }
  }
}
</script>

<style scoped>
.inactive {
  opacity: 0.5;
  pointer-events: none;
}
.btn-get-code {
  background: transparent;
  border: 1px solid #4bb0fe;
  color: #4bb0fe;
  height: 40px;
  padding: 0 20px;
}
</style>
